import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ErrorPage } from './ErrorPage'

interface State {
  error: Error | null
}

/** Catches render errors below it and shows the 500 page instead of a blank screen. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[CityBus ErrorBoundary]', error, info.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    return (
      <ErrorPage
        code={500}
        fullScreen
        onRetry={() => this.setState({ error: null })}
      />
    )
  }
}
